import { OutlinedEditFilter } from '@hose/eui-icons';
import { Button, DatePicker } from '@hose/eui';
import React from 'react';
import moment from 'moment';
var RangePicker = DatePicker.RangePicker;
var useColumnSearch = function (cellRender) {
    var handleDateSearch = function (selectedKeys, confirm) {
        confirm();
    };
    var handleDateReset = function (clearFilters) {
        clearFilters();
    };
    var onDateChange = function (date, setSelectedKeys) {
        if (date === null || date === void 0 ? void 0 : date.length) {
            date[0] = moment(formatTime(date[0], '0', '0', '0', '0'));
            date[1] = moment(formatTime(date[1], '23', '59', '59', '999'));
        }
        setSelectedKeys(date);
    };
    var formatTime = function (date, h, m, s, ms) {
        date.hour(h);
        date.minute(m);
        date.second(s);
        date.millisecond(ms);
        return date;
    };
    return {
        filterDropdown: function (_a) {
            var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
            return (React.createElement("div", { style: { padding: 4, width: '264px' }, onKeyDown: function (e) { return e.stopPropagation(); } },
                React.createElement(RangePicker, { style: { marginBottom: '8px' }, value: selectedKeys, onChange: function (date) { return onDateChange(date, setSelectedKeys); } }),
                React.createElement("div", { style: { width: '100%', display: 'flex', justifyContent: 'end' } },
                    React.createElement(Button, { category: "secondary", onClick: function () { return clearFilters && handleDateReset(clearFilters); }, size: "small", style: { width: 40, marginRight: '4px' } }, "\u91CD\u7F6E"),
                    React.createElement(Button, { category: "primary", onClick: function () { return handleDateSearch(selectedKeys, confirm); }, size: "small", style: { width: 40 } }, "\u786E\u8BA4"))));
        },
        filterIcon: function () { return (React.createElement(OutlinedEditFilter, { fontSize: 16, style: { color: 'var(--eui-icon-n2)' } })); },
        render: cellRender
    };
};
export default useColumnSearch;
